import { useState, useCallback, useEffect } from 'react'

const storageName = 'userData'
export const Roles = { Admin: 'admin', Moderator: 'moderator', Officer: 'officer', Analytic: 'analytic', User: 'user' }

export const useAuth = () => {
  const [token, setToken] = useState(null)
  const [ready, setReady] = useState(false)
  const [tokenExp, setTokenExp] = useState(null)
  const [email, setEmail] = useState(null)
  const [role, setRole] = useState(null)
  const [client, setClient] = useState(null)
  const [team, setTeam] = useState(null)


  const login = useCallback(({ token, tokenExp, email, role, client, team }) => {
    setToken(token)
    setTokenExp(tokenExp)
    setEmail(email)
    setClient(client)
    setRole(role)

    setTeam(team)

    localStorage.setItem(storageName, JSON.stringify({
      token, tokenExp, email, role, client, team
    }))
  }, [])


  const logout = useCallback(() => {
    setToken(null)
    setTokenExp(null)
    setEmail(null)
    setRole(null)
    setClient(null)
    setTeam(null)
    localStorage.removeItem(storageName)
  }, [])


  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(storageName))

    if (data && data.token) {
      const token_exp_format = Math.floor(Date.now() / 1000)
      //console.log(Number.isInteger(data.tokenExp));
      if (Number.isInteger(data.tokenExp) && data.tokenExp < token_exp_format) {
        //if token expired force logout        
        logout()
      } else {
        login(data)
      }

    }
    setReady(true)
  }, [login, logout])


  return { login, logout, role, email, client, team, token, tokenExp, ready }
}
